import shortid from 'shortid';

export function handleLoadDayPlan(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = false;
    newState.recipeChanged = false;

    newState.activeMealHash = '';
    newState.meals = {};
    newState.foodGroups = {};
    newState.foods = {};
    newState.modifications = {};
    newState.titles = {};
    newState.descriptions = {};
    newState.activities = {};
    newState.energyOutputSettings = {};
    newState.trainings = {};
    newState.lectureTaskComplete = false;
    newState.lectureTaskCompleteSaved = false;

    if (typeof action.data.empty !== 'undefined') return newState;

    // Set meals
    for (let mealHash in action.data.state.meals) {
        let meal = action.data.state.meals[mealHash];
        if (meal.meal_id * 1 === 0) continue;
        let profileIds = meal.profile_ids.split(',').map(profileId => profileId * 1);

        // In LECTURE mode, remap the mealHash key (not just profileIds inside the meal)
        // so that all data structures use a consistent key based on the target profile.
        // This fixes the case where the sample task was saved with an admin profile ID
        // that differs from both the target profile ID and the student's own profile ID.
        let effectiveMealHash = mealHash;
        if(state.appMode === 'LECTURE' || state.appMode === 'NUTRIKUCHAR') {
            if(typeof state.appModeData.profileId === 'number') {
                profileIds = [state.appModeData.profileId];
                effectiveMealHash = mealHash.split('|')[0] + '|' + state.appModeData.profileId;
            }
        }

        let mealTime = meal.meal_time.split(':');
        newState.meals[effectiveMealHash] = {
            mealId: meal.meal_id,
            profiles: profileIds,
            startHour: mealTime[0] * 1,
            startMinute: mealTime[1] * 1,
            profi_comment: meal.profi_comment
        };

        newState.titles[effectiveMealHash] = meal.title;
        newState.descriptions[effectiveMealHash] = meal.description;

        // Create food groups, if any
        newState.foodGroups[effectiveMealHash] = {};
        for(let groupKey in action.data.state.groups[mealHash]) {
            newState.foodGroups[effectiveMealHash][groupKey] = {
                id: groupKey,
                type: action.data.state.groups[mealHash][groupKey].type,
                title: action.data.state.groups[mealHash][groupKey].title,
                description: action.data.state.groups[mealHash][groupKey].description,
                item_order: action.data.state.groups[mealHash][groupKey].item_order,
                from_recipe_id: action.data.state.groups[mealHash][groupKey].from_recipe_id,
                gastro_data: action.data.state.groups[mealHash][groupKey].gastro_data,
                opened: true
            };
        }

        // Set meal foods
        newState.foods[effectiveMealHash] = [];
        for (let foodKey in action.data.state.foods[mealHash]) {
            let food = action.data.state.foods[mealHash][foodKey];
            if(typeof newState.foods[effectiveMealHash] == "undefined") newState.foods[effectiveMealHash] = {};

            let foodStruct = {
                id: food.internal_id,
                food_id: food.item_id,
                group_id: food.group_id,
                image: "https://www.zofapp.cz/data/zof/item/" + food.item_id + ".svg",
                title: food.title,
                weight: food.weight,
                is_drink: food.is_drink
            };
            newState.foods[effectiveMealHash] = [...newState.foods[effectiveMealHash], foodStruct];
        }
    }

    // Set food modifications
    for(let mealHash in action.data.state.modifications) {
        let modification = action.data.state.modifications[mealHash];
        for(let foodId in modification) {
            modification[foodId].map(modId => {
                if (typeof newState.modifications[foodId] == "undefined") {
                    newState.modifications[foodId] = [];
                }
                newState.modifications[foodId] = [...newState.modifications[foodId], modId];
            });
        }
    }

    // Set energy output
    newState.energyOutputSettings = {};
    for (let profileId in action.data.state.energyOutputSettings) {
        let exp = action.data.state.energyOutputSettings[profileId];
        newState.energyOutputSettings[profileId] = {
            coefficientId: exp.coefficientId,
            amount: exp.amount,
            unit: exp.unit
        };
    }

    // Set trainings
    for (let trainingId in action.data.state.trainings) {
        trainingId = trainingId * 1;
        let t = action.data.state.trainings[trainingId];
        newState.trainings[trainingId] = {
            id: trainingId,
            start: t.start,
            length: t.length,
            description: t.description
        };
    }
    return newState;
}

export function handleAddMeal(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;

    let hashProfilesPart = action.data.profiles.sort((a, b) => a - b).join(',');

    let hash;
    if(action.data.mealId == 50) {
        // Pitny rezim — generate hash based on existing drink regime meals (ID range 50–69)
        let newMealType = 50;
        let newMealHash = newMealType + '|' + hashProfilesPart;
        while(typeof newState.meals[newMealHash] !== 'undefined') {
            newMealType++;
            if(newMealType > 69) break;
            newMealHash = newMealType + '|' + hashProfilesPart;
        }

        if (typeof newState.meals[newMealHash] === 'undefined') {
            hash = newMealHash;
        } else {
            return newState;
        }
    } else {
        hash = action.data.mealId + '|' + hashProfilesPart;
    }

    if (typeof newState.meals[hash] !== 'undefined') {
        return newState;
    }

    action.data.profiles.map(profileId => profileId * 1);

    newState.meals[hash] = {
        mealId: action.data.mealId,
        startHour: action.data.startHour,
        startMinute: action.data.startMinute,
        profiles: action.data.profiles
    };

    const newGroupId = shortid();
    if(typeof newState.foodGroups[hash] == 'undefined') {
        newState.foodGroups[hash] = {};
    }

    newState.foodGroups[hash][newGroupId] = {
        id: newGroupId,
        type: 'plate',
        title: '',
        opened: true
    };

    if (typeof newState.descriptions[hash] == "undefined") newState.descriptions[hash] = "";
    if (typeof newState.titles[hash] == "undefined") newState.titles[hash] = "";
    if (typeof newState.foods[hash] == "undefined") newState.foods[hash] = [];
    return newState;
}

export function handleRemoveMeal(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;

    delete newState.meals[action.data];
    delete newState.foods[action.data];
    delete newState.foodGroups[action.data];
    delete newState.modifications[action.data];
    delete newState.titles[action.data];
    delete newState.descriptions[action.data];
    newState.activeMealHash = '';
    return newState;
}

export function handleUpdateMeal(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;

    action.data.profiles.map(profileId => profileId * 1);

    let mealRecord = newState.meals[action.data.mealHash];
    delete newState.meals[action.data.mealHash];

    let newHash = action.data.mealId + '|' + action.data.profiles.sort((a, b) => a - b).join(',');

    newState.meals[newHash] = mealRecord;
    newState.meals[newHash].mealId = action.data.mealId * 1;
    newState.meals[newHash].startHour = action.data.startHour;
    newState.meals[newHash].startMinute = action.data.startMinute;
    newState.meals[newHash].profiles = action.data.profiles;

    let foodsToCopy = newState.foods[action.data.mealHash];
    delete newState.foods[action.data.mealHash];
    newState.foods[newHash] = foodsToCopy;

    let titlesToCopy = newState.titles[action.data.mealHash];
    delete newState.titles[action.data.mealHash];
    newState.titles[newHash] = titlesToCopy;

    let descriptionsToCopy = newState.descriptions[action.data.mealHash];
    delete newState.descriptions[action.data.mealHash];
    newState.descriptions[newHash] = descriptionsToCopy;

    let foodGroupsToCopy = newState.foodGroups[action.data.mealHash];
    delete newState.foodGroups[action.data.mealHash];
    newState.foodGroups[newHash] = foodGroupsToCopy;

    return newState;
}

export function handleClearMeal(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    newState.foods[action.data.mealHash] = [];
    newState.titles[action.data.mealHash] = '';
    return newState;
}

export function handleSetMealDescription(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;
    newState.recipeChanged = true;

    newState.descriptions[action.data.mealHash] = action.data.description;
    return newState;
}
